import {Route, Routes} from 'react-router-dom';
import HomePage from '../homePage/HomePage';
import Finances from '../finances/Finances';
import Analytics from '../analytics/Analytics';
import RecipesMain from '../recipes/RecipesMain';
import CustomersMain from '../customers/CustomersMain';
import ItemsMain from '../items/ItemsMain';
import Settings from "../settings/Settings";
import {OrdersMain} from "../orders/OrdersMain";
import FeedbackPage from '../feedback/FeedbackPage';

function RoutesManager() {
    return (
        <Routes>
            <Route path="/app" element={<HomePage/>}/>
            <Route path="/app/items/*" element={<ItemsMain/>}/>
            <Route path="/app/orders/*" element={<OrdersMain/>}/>
            <Route path="/app/recipes/*" element={<RecipesMain/>}/>
            <Route path="/app/customers/*" element={<CustomersMain/>}/>
            <Route path="/app/analytics" element={<Analytics/>}/>
            <Route path="/app/finances" element={<Finances/>}/>
            <Route path="/app/settings" element={<Settings/>}/>
            <Route path="/app/feedback" element={<FeedbackPage/>}/>
        </Routes>
    );
}

export default RoutesManager;
